import React from 'react'
import { Form, FormSpy, Field } from 'react-final-form'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

import MEdit from 'components/forms/MEdit'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      display: 'flex',
      minWidth: '100%',
      maxWidth: '100%',
      marginBottom: theme.spacing(5),
    },
  })
)

type Props = {
  open: boolean
  setOpen: any
  confirm: any
  defaultValue?: any
}

const MSourcePairingDialog: React.FC<Props> = ({ open, setOpen, confirm, defaultValue }) => {
  const classes = useStyles()

  const handleEditClose = () => {
    setOpen(false)
  }

  const handleSave = async (values) => {
    await confirm(values, defaultValue)
    setOpen(false)
  }

  const onChange = (props) => {}

  return (
    <Dialog
      fullWidth={true}
      maxWidth={'sm'}
      open={open}
      onClose={handleEditClose}
      aria-labelledby='max-width-dialog-title'
    >
      <DialogTitle id='max-width-dialog-title'>Source Name</DialogTitle>
      <DialogContent>
        <Form
          initialValues={defaultValue}
          onSubmit={confirm}
          render={({ handleSubmit, values }) => (
            <form onSubmit={handleSubmit} noValidate>
              <FormSpy subscription={{ values: true }} onChange={onChange} />
              <Field
                className={classes.formControl}
                name='source_name'
                label='Source Name'
                render={(props) => <MEdit {...props} />}
              />

              <Field
                className={classes.formControl}
                name='ga4_sources'
                label='GA4 Sources'
                render={(props) => <MEdit {...props} multiline={true}/>}
              />

              <DialogActions>
                <Button onClick={() => handleSave(values)} color='primary'>
                  Save
                </Button>
              </DialogActions>
            </form>
          )}
        />
      </DialogContent>
    </Dialog>
  )
}

export default MSourcePairingDialog
